module.exports = __webpack_public_path__ + "img/martha1.b40cec0c.png";